"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientShow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const client_1 = require("../../../model/client");
const auth_1 = require("../../../utils/auth");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const right_panel_1 = require("../../../widgets/right_panel");
const tabs_1 = require("../../../widgets/tabs");
const invoice_print_1 = require("../invoice/invoice_print");
const client_form_1 = require("./client_form");
// 1/« infos perso » :
// il faudrait voir le mail (avec un lien qui ouvre directement un mail à envoyer via l’adresse « clientsesame@gmail.com » )
// le num de tel (avec si possible un espace tous les 2 chiffres pour mes faibles yeux !)
// les documents non remis (ceux non cochés au moment de la création du client)
// un seul d à adresse email et accent sur téléphone
exports.ClientShow = {
    client: {},
    sendMail: false,
    currentTab: "contracts",
    oncreate(vnode) {
        exports.ClientShow.sendMail = false;
        this.fetch(parseInt(vnode.attrs.id));
    },
    fetch(id) {
        exports.ClientShow.client = { id: id };
        if (id !== undefined) {
            client_1.ClientProvider.show(id).then((client) => {
                exports.ClientShow.client = client;
                mithril_1.default.redraw();
            });
        }
    },
    renderShowContract() {
        return (0, mithril_1.default)("div", (0, mithril_1.default)("a.button.is-info", { href: `#/clients/${exports.ClientShow.client.id}/print` }, (0, helpers_1.iconSpan)("fa-file-contract"), (0, mithril_1.default)("span", "Afficher le contrat")));
    },
    renderDocumentReady() {
        return (0, mithril_1.default)("div", (0, mithril_1.default)("h2", "Documents légaux"), (0, helpers_1.renderProperties)({
            "Contrat signé le": exports.ClientShow.client.contract_signed_at ? app_1.App.shortDateFormat(exports.ClientShow.client.contract_signed_at) : (0, helpers_1.empty)(),
        }), helpers_1.capsuleGroup.apply(this, [["Diplôme", "diploma"],
            ["Document d'identité", "identity_document"],
            ["Assurance", "insurance"],
            ["Statut Légal", "legal_status"],
            ["Preuve de résidence", "proof_of_residency"]
        ].map(([label, key]) => {
            let url = key;
            key = `has_${key}`;
            return (0, mithril_1.default)("label", { class: "checkbox" }, (0, mithril_1.default)("input", { type: "checkbox", checked: exports.ClientShow.client[key], onchange: (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    let client = exports.ClientShow.client;
                    client[key] = !client[key];
                    app_1.App.get(`/clients/${exports.ClientShow.client.id}/toggle_document/${url}`).then((data) => {
                        client[key] = data[key];
                        mithril_1.default.redraw();
                    });
                }
            }), label);
        })));
    },
    renderLinkToForgotPassword() {
        let resetToken = exports.ClientShow.client.password_reset_token;
        if (exports.ClientShow.client.password_reset_token) {
            return (0, mithril_1.default)("div", (0, mithril_1.default)("h2", "Lien pour changer le mot de passe (valide 3 jours!)"), (0, helpers_1.tag)((0, mithril_1.default)("a", { href: `#/reset-password/${exports.ClientShow.client.email}/${resetToken}` }, "Sauvegarder le lien (clic-droit)")));
        }
        else {
            return undefined;
        }
    },
    renderInfos() {
        return (0, mithril_1.default)("div", {
            class: "content",
            key: "details",
            dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-file-alt", "is-small"), (0, mithril_1.default)("span", "Infos perso."))
        }, (0, mithril_1.default)("div", { class: "client-infos" }, (0, mithril_1.default)("div", { class: "contact" }, (0, helpers_1.capsuleGroup)((0, mithril_1.default)("span", { dataLabel: "E-mail" }, (0, helpers_1.capsule)((0, helpers_1.iconSpan)("fa-at"), (0, helpers_1.empty)((0, helpers_1.mailto)(exports.ClientShow.client.email)), "is-success")), (0, mithril_1.default)("span", { dataLabel: "Portable" }, (0, helpers_1.capsule)((0, helpers_1.iconSpan)("fa-mobile"), (0, helpers_1.empty)((0, helpers_1.phoneto)(exports.ClientShow.client.cellphone)), "is-warning")), (0, mithril_1.default)("span", { dataLabel: "Téléphone" }, (0, helpers_1.capsule)((0, helpers_1.iconSpan)("fa-phone"), (0, helpers_1.empty)((0, helpers_1.phoneto)(exports.ClientShow.client.telephone)), "is-link"))), (0, mithril_1.default)("hr"), (0, form_for_1.checkbox)([(0, helpers_1.iconSpan)("fa-envelope"), (0, mithril_1.default)("span", "Courrier disponible?")], "has_mail", exports.ClientShow.client, {
            oninput: (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                app_1.App.get(`/clients/${exports.ClientShow.client.id}/toggle_has_mail`).then((data) => {
                    exports.ClientShow.client.has_mail = data.active;
                    mithril_1.default.redraw();
                });
            }
        }), (0, helpers_1.ifTrue)(exports.ClientShow.client.has_mail && !exports.ClientShow.sendMail, (0, mithril_1.default)("div", (0, helpers_1.button)("Notifier le client par email", {
            onclick: () => {
                app_1.App.get(`/clients/${exports.ClientShow.client.id}/send_has_mail`).then((_data) => {
                    exports.ClientShow.sendMail = true;
                    mithril_1.default.redraw();
                });
            },
            class: "is-primary"
        })))), (0, mithril_1.default)("hr"), (0, mithril_1.default)("div", (0, mithril_1.default)("h2", "Adresse"), (0, helpers_1.copiable)((0, mithril_1.default)("div", (0, mithril_1.default)("p", exports.ClientShow.client.address), (0, mithril_1.default)("p", `${exports.ClientShow.client.postal_code} ${exports.ClientShow.client.city}`), (0, mithril_1.default)("p", `${exports.ClientShow.client.country}`)))), (0, mithril_1.default)("hr"), (0, mithril_1.default)("div", { class: "" }, (0, mithril_1.default)("h2", "Infos professionnelles"), (0, helpers_1.renderProperties)({
            "Profession": exports.ClientShow.client.job_title,
            "Raison sociale": exports.ClientShow.client.company_name,
            "Statut": exports.ClientShow.client.legal_status,
            "SIRET": exports.ClientShow.client.siret,
            "Code comptable": exports.ClientShow.client.account_code,
        }), this.renderDocumentReady(), (0, mithril_1.default)("hr"), this.renderLinkToForgotPassword())));
    },
    renderContracts(contracts) {
        return [
            (0, mithril_1.default)("h3", "Forfaits actifs & non-payés"),
            (0, mithril_1.default)("table", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "Nom"), (0, mithril_1.default)("th", "Consommé"), (0, mithril_1.default)("th", "Actif?"), (0, mithril_1.default)("th", "Quota Ann. libre"), (0, mithril_1.default)("th", "Créé le"), (0, mithril_1.default)("th", "Expire le"), (0, mithril_1.default)("th")), (0, helpers_1.ifAny)(contracts, () => {
                return contracts.map((p) => {
                    const contractIsPaid = !exports.ClientShow.client.payments.find(x => x.contract_id == p.id && !x.paid);
                    const visible = (p.active || !contractIsPaid);
                    return (0, helpers_1.ifTrue)(visible, (0, mithril_1.default)("tr", (0, mithril_1.default)("td", (0, mithril_1.default)(".tags.has-addons", (0, mithril_1.default)(`span.tag.${contractIsPaid ? "is-success" : "is-danger"}`, ""), (0, mithril_1.default)("span.tag", right_panel_1.RightPanel.linkTo(`${p.id} - ${p.name}`, "contracts", p.id, "show")))), (0, mithril_1.default)("td", (0, helpers_1.tag)(`${(0, helpers_1.minutesToUnit)(p.initial_minutes - p.remaining_minutes)} / ${(0, helpers_1.minutesToUnit)(p.initial_minutes)}`)), (0, mithril_1.default)("td", (0, helpers_1.ifTrue)(p.active, (0, helpers_1.tag)("OUI", "success"), (0, helpers_1.tag)("NON", "danger"))), (0, mithril_1.default)("td", (0, helpers_1.tag)((0, helpers_1.minutesToUnit)(p.remaining_cancelable_free_minutes))), (0, mithril_1.default)("td", (0, helpers_1.tag)((0, helpers_1.formatTime)(p.created_at))), (0, mithril_1.default)("td", (0, helpers_1.tag)((0, helpers_1.formatTime)(p.expires_at, false))), (0, mithril_1.default)("td", (0, helpers_1.linkTo)(invoice_print_1.InvoicePrint.link(p.invoice_id), (0, helpers_1.iconSpan)("fa-file-signature"), true))));
                });
            }, () => {
                return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 6, style: "text-align: center; font-style: italic;" }, "Pas de forfait actif"));
            }))
        ];
    },
    renderBookings(bookings) {
        return [
            (0, mithril_1.default)("h3", `Réservations à venir (${bookings.length})`),
            (0, mithril_1.default)("table", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "Date"), (0, mithril_1.default)("th", "Durée"), (0, mithril_1.default)("th", "Materiel")), (0, helpers_1.ifAny)(bookings, () => {
                return bookings.map((p) => {
                    return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", right_panel_1.RightPanel.linkTo((0, helpers_1.formatTime)(p.date), "bookings", p.id, "show")), (0, mithril_1.default)("td", (0, helpers_1.minutesToUnit)(p.duration)), (0, mithril_1.default)("td", (0, helpers_1.tags)(p.additional_services)));
                });
            }, () => {
                return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 4, style: "text-align: center; font-style: italic;" }, "Pas de réservations à venir"));
            }))
        ];
    },
    renderCanceledBookings(bookings) {
        return [
            (0, mithril_1.default)("h3", `Réservations annulées (${bookings.length})`),
            (0, mithril_1.default)("table", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "Résa du"), (0, mithril_1.default)("th", "Durée"), (0, mithril_1.default)("th", "Annulé par")), (0, helpers_1.ifAny)(bookings, () => {
                return bookings.map((p) => {
                    return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", right_panel_1.RightPanel.linkTo((0, helpers_1.formatTime)(p.date), "bookings", p.id, "show")), (0, mithril_1.default)("td", (0, helpers_1.minutesToUnit)(p.duration)), (0, mithril_1.default)("td", right_panel_1.RightPanel.linkTo(p.canceled_by.name, "clients", p.canceled_by.id, "show")));
                });
            }, () => {
                return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 4, style: "text-align: center; font-style: italic;" }, "Pas de réservations à venir"));
            }))
        ];
    },
    renderContractLink() {
        const kpi1 = (0, helpers_1.kpi)((0, helpers_1.minutesToUnit)(exports.ClientShow.client.remaining_bookable_time), "Restante à réserver");
        const kpi2 = (0, helpers_1.kpi)((0, helpers_1.minutesToUnit)(exports.ClientShow.client.total_bookable_time - exports.ClientShow.client.remaining_bookable_time), "Déjà posée");
        return (0, mithril_1.default)("div", {
            class: "content",
            key: "contracts",
            dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-star"), (0, mithril_1.default)("span", "Forfaits & Résas"))
        }, (0, mithril_1.default)("div"), (0, mithril_1.default)("div", (0, form_for_1.columns)(kpi1, kpi2)), (0, mithril_1.default)("hr"), this.renderContracts(exports.ClientShow.client.contracts || []), (0, mithril_1.default)("br"), this.renderBookings(exports.ClientShow.client.incoming_bookings || []), this.renderCanceledBookings(exports.ClientShow.client.canceled_bookings || []));
    },
    renderPayment(p) {
        return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo(`#${p.contract_id}`, "contracts", p.contract_id, "show"))), (0, mithril_1.default)("td", (0, helpers_1.small)((0, helpers_1.moneyToString)(p.value))), (0, mithril_1.default)("td", (0, helpers_1.tag)(app_1.App.moment(p.due_at).format("LLL"))), (0, mithril_1.default)("td", p.paid ? (0, helpers_1.tag)(app_1.App.moment(p.paid_at).format("LLL")) : (0, helpers_1.tag)("NON", "danger")));
    },
    renderFinancial() {
        exports.ClientShow.client.payments = exports.ClientShow.client.payments || [];
        return (0, mithril_1.default)("div", {
            class: "content",
            key: "payments",
            dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-euro-sign"), (0, mithril_1.default)("span", "Financier"))
        }, (0, mithril_1.default)("table.table", (0, mithril_1.default)("thead", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "# forfait"), (0, mithril_1.default)("th", "Montant"), (0, mithril_1.default)("th", "À payer le"), (0, mithril_1.default)("th", "Payé?"))), (0, mithril_1.default)("tbody", (0, helpers_1.ifAny)(exports.ClientShow.client.payments, (payments) => {
            return payments.map(p => this.renderPayment(p));
        }, (_x) => {
            return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 4, style: "text-align: center;" }, (0, helpers_1.empty)()));
        }))));
    },
    renderTabs() {
        return (0, mithril_1.default)(tabs_1.Tabs, {
            selected: this.currentTab,
            ontabchange: (pane) => { this.currentTab = pane; },
            class: "is-centered"
        }, this.renderContractLink(), this.renderInfos(), this.renderFinancial());
    },
    view(_vnode) {
        let client = exports.ClientShow.client;
        return (0, mithril_1.default)(".content", (0, mithril_1.default)("h3", [client.first_name, client.last_name].join(" ")), (0, helpers_1.level)({
            left: (0, mithril_1.default)("p", { class: "buttons" }, (0, mithril_1.default)("a", {
                class: "button is-primary",
                onclick: (e) => { e.preventDefault(); client_form_1.ClientForm.show(client); }
            }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Éditer")), (0, helpers_1.ifTrue)(client.enabled, (0, mithril_1.default)("a", {
                class: "button is-warning",
                onclick: (e) => { e.preventDefault(); auth_1.Auth.impersonate(client.id); }
            }, (0, helpers_1.iconSpan)("fa-user-ninja"), (0, mithril_1.default)("span", "Impersonner"))), this.renderShowContract())
        }), this.renderTabs());
    }
};
